import React, { Component } from 'react';
import DisplayBlock from './DisplayBlock';

class DisplayBlocks extends Component {

	render() {
		return (
			<div className="row shadow rounded p-2 m-2">
				{this.props.data.map((block, index) => (
					<DisplayBlock
						key={index}
						data={block}
					/>
				))}
			</div>
		);
	}
}

export default (DisplayBlocks)
